import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  boxDoodleSearch: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    flexGrow: 1,
    marginTop: 52,
  },
  doodleImage: {
    height: 240,
    width: 360,
    // MUI v5+: down('xs') generates @media(max-width:-0.05px) which never
    // matches.  down('sm') = @media(max-width:599.95px), equivalent to v4's
    // down('xs').
    [theme.breakpoints.down('sm')]: { height: 160 },
  }
}));

export { useStyles };
